var _path, _g, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20445_15837",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 10,
    height: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.429688 0.414062H9.38511V9.36981H0.429688V0.414062Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20445_15837)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8982 9.3699C4.26154 9.3699 3.6207 9.23531 3.02112 8.95781C2.84445 8.88698 2.67904 8.82031 2.56029 8.82031C2.42362 8.82115 2.23987 8.88448 2.06237 8.94573C1.6982 9.07073 1.24487 9.22656 0.909453 8.8924C0.575286 8.55781 0.729453 8.10573 0.85362 7.74198C0.91487 7.56281 0.977786 7.37781 0.977786 7.23781C0.977786 7.12281 0.92237 6.97615 0.83737 6.7649C0.0569529 5.07948 0.417786 3.04823 1.74154 1.72531C2.58654 0.879896 3.71112 0.414062 4.9082 0.414062C6.10529 0.414062 7.23029 0.879479 8.07529 1.7249C9.82195 3.47156 9.82195 6.31323 8.07529 8.0599C7.21904 8.91656 6.06612 9.3699 4.8982 9.3699Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.55115 5.48177C6.32115 5.48177 6.13281 5.29552 6.13281 5.0651C6.13281 4.83469 6.3174 4.64844 6.5474 4.64844H6.55115C6.78115 4.64844 6.96781 4.83469 6.96781 5.0651C6.96781 5.29552 6.78115 5.48177 6.55115 5.48177Z",
    fill: "#051742"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.88708 5.48177C4.65708 5.48177 4.46875 5.29552 4.46875 5.0651C4.46875 4.83469 4.65292 4.64844 4.88333 4.64844H4.88708C5.11708 4.64844 5.30375 4.83469 5.30375 5.0651C5.30375 5.29552 5.11708 5.48177 4.88708 5.48177Z",
    fill: "#051742"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2074 5.48177C2.9774 5.48177 2.78906 5.29552 2.78906 5.0651C2.78906 4.83469 2.97365 4.64844 3.20365 4.64844H3.2074C3.4374 4.64844 3.62406 4.83469 3.62406 5.0651C3.62406 5.29552 3.4374 5.48177 3.2074 5.48177Z",
    fill: "#051742"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.b811cf3e278e33b3556d0aca21984a56.svg";
export { ForwardRef as ReactComponent };